import * as React from 'react';
import cx from 'classnames';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import ReceiveAwardModalStore from '@src/business-components/receive-award-modal/store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import TinyInput from '@src/components/tiny-input';
import PhoneInput from '@src/components/phone-input';
const ReceiveAwardModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  const renderContent = () => {
    if (store.isCheckModal) {
      return (
        <React.Fragment>
          <div className={cx(styles.confirm_content, (store.isCheckModal || store.isFinished) && styles.confirm_content_check)}>
            <div className={styles.contentItem}>
              <div className={styles.contentLabel}>收件人姓名：</div>
              <div className={styles.contentItemText}> {store.nameInput.value}</div>
            </div>

            <div className={styles.contentItem}>
              <div className={styles.contentLabel}>收件手机号：</div>
              <div className={styles.contentItemText}>{store.phoneInput.value}</div>
            </div>

            <div className={styles.contentItem}>
              <div className={styles.contentLabel}>收件地址：</div>
              <div className={styles.contentItemText}>{store.addressInput.value}</div>
            </div>
          </div>
          {store.isFinished ? (
            <div className={styles.completedText}>*中奖登记已完成，奖品将在活动结束后一个月内陆续发出，请分析员耐心等待~</div>
          ) : (
            <div className={cx(styles.footerContent, styles.confirmFooterContent)}>
              <div className={styles.btnBox}>
                <Link className={styles.modalShowBtn} onClick={store.onConfirmBtnClick} />
                <Link className={styles.modalBackBtn} onClick={store.onClickCancelSubmit} />
              </div>

              <div className={cx(styles.warnTip, store.isCheckModal && styles.warnTip_check)} dangerouslySetInnerHTML={{ __html: store.warnTip }} />
            </div>
          )}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.content}>
          <div className={styles.contentItem}>
            <div className={styles.contentLabel}>收件人姓名：</div>

            <TinyInput maxLength={50} type="text" name="name" autoComplete="off" className={styles.nameInput} store={store.nameInput} />
          </div>
          <div className={styles.contentItem}>
            <div className={styles.contentLabel}>收件手机号：</div>

            <PhoneInput maxLength={50} type="number" name="phone" autoComplete="off" className={styles.phoneInput} store={store.phoneInput} />
          </div>
          <div className={styles.contentItem}>
            <div className={styles.contentLabel}>收件地址：</div>

            <TinyInput maxLength={300} types={'textarea'} name="address" autoComplete="off" className={styles.addressInput} store={store.addressInput} />
          </div>
        </div>

        {!store.isFinished && (
          <div className={styles.footerContent}>
            <div className={styles.btnBox}>
              <Link className={styles.modalCancelBtn} onClick={store.onClickClose} />
              <Link className={styles.modalSubmitBtn} onClick={store.onConfirmBtnClick} />
            </div>
            <div className={styles.warnTip} dangerouslySetInnerHTML={{ __html: store.warnTip }} />
          </div>
        )}
      </React.Fragment>
    );
  };

  const renderTitle = () => {
    if (store.isFinished) {
      return <div className={styles.winningCompleted} />;
    } else {
      if (store.isCheckModal) {
        return <div className={styles.winningConfirmation} />;
      } else {
        return <div className={styles.winningRegistration} />;
      }
    }
  };

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.receiveAwardModalRoot}>
        {renderContent()}

        {renderTitle()}

        <Link className={styles.close} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(ReceiveAwardModal, ReceiveAwardModalStore);
